import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.timeMiddleware(_ctx.postNode.time)) + " ", 1),
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.postNode.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 6,
          offset: 6,
          style: {"text-align":"right"}
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "post-head-number", {}, () => [
              _createElementVNode("span", null, "No." + _toDisplayString(_ctx.postNode.id), 1)
            ]),
            _hoisted_3,
            _renderSlot(_ctx.$slots, "post-head-tag")
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}